import { store } from "../store";
import { changeHeaders } from "../store/request";

export type TrackingAfterConsentPayload = {
    headHtml: string;
};

/**
 * GET scripts/tracking-after-consent — те же заголовки, что у RTK (prepareHeaders / changeHeaders).
 */
export async function fetchTrackingAfterConsent(): Promise<TrackingAfterConsentPayload> {
    const headers = new Headers({
        Accept: "application/json",
    });
    changeHeaders(headers, { getState: () => store.getState() });

    const res = await fetch("/api/v1/scripts/tracking-after-consent", {
        method: "GET",
        credentials: "same-origin",
        headers,
    });

    if (!res.ok) {
        throw new Error(`tracking-after-consent HTTP ${res.status}`);
    }

    return res.json() as Promise<TrackingAfterConsentPayload>;
}
